module.exports = __webpack_public_path__ + "img/w68.67fefa16.svg";